// @ts-ignore
export const hasAddress = (location): boolean => {
  if (!location) {
    return false;
  }
  const { name = '', street1 = '', street2 = '', city = '', zip = '', state = '' } = location;
  return [name, street1, street2, city, state, zip].filter(Boolean).length > 0;
};
export default hasAddress;

export const getLocationVenuesLink = (city?: string, stateCode?: string) => {
  if (city && stateCode) {
    // Washington DC is a special case
    if (stateCode.toLocaleLowerCase() === 'dc') {
      return '/marketplace/wedding-reception-venues-washington-dc?sort=featured';
    }

    return `/marketplace/wedding-reception-venues-${city
      .replace(/ /g, '-')
      .toLocaleLowerCase()}-${stateCode.toLocaleLowerCase()}?sort=featured`;
  }

  return '/marketplace/wedding-reception-venues/';
};
